(function ($) {
	var ui = kendo.ui,
		Widget = ui.Widget;
	var KontoUpload = Widget.extend({
		init: function (element, options) {
			options = $.extend(true, {}, this.options, options);
			
			var uploadFunc = (options.uploadSuccess || function (e) {}).bind(this);
			var removeFunc = (options.removeSuccess || function (e) {}).bind(this);
			if (!options.success) {
				options.success = function (e) {
					if (e.operation == "upload") {
						uploadFunc(e);
					}
					else if (e.operation == "remove") {
						removeFunc(e);
					}
				};
			}
			var selectFunc = (options.select || function (e) {}).bind(this);
			var wrappedSelect = function (e) {
				for (var i = 0; i < e.files.length; ++i) {
					var f = e.files[i];
					f.id = "";
					f.filename = f.name;
					//f.name = "";
				}
				selectFunc(e);
			};
			options.select = wrappedSelect.bind(this);
			
			var userSuccess = options.success.bind(this);
			var wrappedSuccess = function (e) {
				var resp = e.response;
				for (var i = 0; i < e.files.length; ++i) {
					var f = e.files[i];
					f.id = resp.id;
					//f.filename = f.name;
					f.name = resp.id;
				}
				userSuccess(e);
			};
			options.success = wrappedSuccess.bind(this);
			options.async.saveUrl = kontorouter.getModulPath(options.async.saveUrl);
			options.async.removeUrl = kontorouter.getModulPath(options.async.removeUrl);
			
			Widget.fn.init.call(this, element, options);
			this.element.kendoUpload(options);
		},
		options: {
			name: "KontoUpload",
			async: {
				saveUrl: "uploadcache/save?fileUpload",
				saveField: "file-save",
				removeUrl: "uploadcache/remove?fileUpload",
				removeField: "file-remove",
				autoUpload: true
			},
			localization: {
				select: "Dodaj datoteku",
				cancel: "Odustani",
				dropFilesHere: "Dovucite datoteke ovdje (Drag&Drop).",
				remove: "Obriši",
				retry: "Pokušaj ponovno",
				invalidFileExtension: "Vrsta datoteke nije dozvoljena.",
				uploadSuccess: "Datoteka je uspješno prenesena.",
				uploadFail: "Greška prilikom prijenosa datoteke.",
			},
			error: function (e) {
				var response = e.XMLHttpRequest.responseText;
				var msg = null;
				try {
					var json = $.parseJSON(response);
					if (json !== null && json.error)
						msg = json.error;
				} catch (e) { } 
				
				if (msg === null) {
					msg = "Greška prilikom operacije \"" + e.operation + "\" <br />";
					msg += "Detalji: " + e.XMLHttpRequest.responseText;
				}
				$.dialogGreska({
					content: msg
				});
			},
			select: function (e) {
			}
		}
	});
	
	ui.plugin(KontoUpload);
} (jQuery));